import { Directive, HostListener } from '@angular/core';

import {RootScopeService} from '../shared-service/root-scope.service';
import { RootScopeDeclare } from '../rootscope-declare';

@Directive({
  selector: '[appSetContainerHeight]'
})
export class SetContainerHeightDirective {

  rootScopeData: RootScopeDeclare;

  constructor(private rootScopeService: RootScopeService) {
    this.getRootScopeData();
    this.setContainerHeight();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  @HostListener('window:resize', ['$event'])
  setContainerHeight(): void {
    let headerHeight = 80; // 80 is header height
    /* if(this.rootScopeData.showDoorBanner) {
      headerHeight = headerHeight + 71; // 71 is doorBanner height
    } */
    this.rootScopeData.leftNavHeight = window.innerWidth >= 992 ? (window.innerHeight - headerHeight) : window.innerHeight;
    this.rootScopeData.contentAreaHeight = window.innerWidth > 576 ? (window.innerHeight - headerHeight) :  (window.innerHeight - 131);
    this.rootScopeData.contentHeight = this.rootScopeData.contentAreaHeight - this.rootScopeData.footerHeight;
  }

}
